import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

export const JsonTable = ({ data }) => {
  if (!data || typeof data !== "object") return null;

  return (
    <>
     
      <TableContainer
        component={Paper}
        sx={{ maxHeight: 300, overflowY: "auto", fontSize: "0.85rem" }}
      >
        <Table stickyHeader size="small" aria-label="json table">
          <TableBody>
            {Object.entries(data).map(([key, value]) => (
              <TableRow key={key}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                >
                  {key}
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    maxWidth: 400,
                  }}
                >
                  {typeof value === "object"
                    ? JSON.stringify(value, null, 2)
                    : String(value)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
